// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal-button-yes {
    background-color: white !important;
    /* color: var(--secondary-color) !important; */
    border: 1px solid var(--secondary-color);
  }
  
  .confirmation-modal-button-no {
    background-color: white;
    color: #dc3545;
    border-color:#dc3545 !important;
  }

  .confirmation-modal-button-yes:hover {
    background-color: var(--secondary-color) !important;
    color: #ffffff !important;
}
.confirmation-modal-button-no:hover {
  background-color: #dc3545 !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ConfirmationModelBox/ConfirmationModelBox.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,8CAA8C;IAC9C,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,mDAAmD;IACnD,yBAAyB;AAC7B;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".confirmation-modal-button-yes {\n    background-color: white !important;\n    /* color: var(--secondary-color) !important; */\n    border: 1px solid var(--secondary-color);\n  }\n  \n  .confirmation-modal-button-no {\n    background-color: white;\n    color: #dc3545;\n    border-color:#dc3545 !important;\n  }\n\n  .confirmation-modal-button-yes:hover {\n    background-color: var(--secondary-color) !important;\n    color: #ffffff !important;\n}\n.confirmation-modal-button-no:hover {\n  background-color: #dc3545 !important;\n  color: #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
